import "./Footer.css";

function Footer() {
    return (
        <footer className="basic-layout-footer">
            <p>© 2025 Monstarbay</p>
        </footer>
    );
}

export default Footer;
